"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_FEE = void 0;
exports.BASE_FEE = 1002500; // Buffer to include usual fees when calculating stream amount
